import { mergeLeft } from 'ramda';
import { writable, derived, get } from 'svelte/store';
import { OrderedMap } from 'immutable';
import { types } from '@commercebear/portal-api';
import jobStore from './jobStore';

export default function jobsStore(sse) {
  if (!sse) {
    throw new TypeError('A `jobsStore` requires a backing SSE');
  }

  const backing = writable(new OrderedMap());
  const { subscribe } = derived(backing, (jobStores, set) => {
    const nested = derived([...jobStores.values()], (jobs) => jobs);
    return nested.subscribe((jobs) => set(jobs));
  });

  function add(job, original = true) {
    backing.update((jobStores) => {
      if (jobStores.has(job.id)) {
        const previousJob = jobStores.get(job.id);
        previousJob.update(mergeLeft(job));
        return jobStores;
      }
      return jobStores.set(job.id, jobStore(sse, {
        ...job,
        status: (original ? types.jobStatus.PENDING : job.status),
      }));
    });
  }

  function replace(jobId, updates) {
    backing.update((jobStores) => {
      if (jobStores.has(jobId)) {
        const removedJobStore = jobStores.delete(jobId);
        return removedJobStore.set(updates.id, jobStore(sse, updates));
      }
      return jobStores.set(updates.id, jobStore(sse, updates));
    });
  }

  function remove(jobId) {
    backing.update((jobStores) => {
      if (jobStores.has(jobId)) {
        return jobStores.delete(jobId);
      }
      return jobStores;
    });
  }

  function clear() {
    backing.set(new OrderedMap());
  }

  function getJobStore(jobId) {
    return get(backing).get(jobId);
  }

  return {
    subscribe,
    add,
    replace,
    remove,
    clear,
    getJobStore,
  };
}
